import React, { Component } from "react";
import styled, { css } from "styled-components";
import { Container, Row, Col, media } from "styled-bootstrap-grid";
import theme from "ui/styles/theme";
import getRelativeUrl from "utils/getRelativeUrl";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "./slides.css";

// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default class CategoriesButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      arrLength: this.props.button.length,
      isMobile: false,
    };
  }

  componentDidMount = () => {
    this.detectMobile();
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2,
    });
  };
  detectMobile = () => {
    const width = window.innerWidth;
    const isMobile = width <= theme.grid.breakpoints.md;

    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  };

  render() {
    const { bgcolor, heading, button } = this.props;
    const { arrLength, isMobile, activeSlide } = this.state;

    const settings = {
      dots: true,
      autoplay: false,
      arrow: true,
      infinite: false,
      slidesToShow: 1.1,
    };

    return (
      <Wrapper bgcolor={bgcolor}>
        <HeroWrapper fluid>
          {this.props.heading && (
            <Row>
              <Col>
                <Heading>{heading}</Heading>
              </Col>
            </Row>
          )}
          {isMobile === true ? (
            <Slider {...settings}>
              {button.map((button, index) => (
                <CardContainer
                  to={getRelativeUrl(button.link_to.link)}
                  key={index}
                >
                  <ImgContainer>
                    <InText className={"text"}>{button.text}</InText>
                    <Img img={button.image.sourceUrl} className={"image"}></Img>
                  </ImgContainer>
                  <UnderText>{button.text}</UnderText>
                </CardContainer>
              ))}
            </Slider>
          ) : (
            <Row alignItems={"center"}>
              {console.log(button.length)}

              {button.map((button, index) => {
                return (
                  <Col
                    key={index}
                    sm={arrLength < 3 ? 6 : arrLength === 4 ? 3 : 4}
                    style={colStyle}
                  >
                    <CardContainer
                      onClick={
                        !button.link_to ? (e) => e.preventDefault() : undefined
                      }
                      aria-disabled={!button.link_to}
                      to={
                        button.link_to
                          ? getRelativeUrl(button.link_to.link)
                          : "#"
                      }
                    >
                      <ImgContainer>
                        <InText className={"text"} textSize={arrLength}>
                          {button.text}
                        </InText>
                        <Img
                          img={button.image.sourceUrl}
                          className={"image"}
                        ></Img>
                      </ImgContainer>
                      <UnderText>{button.text}</UnderText>
                    </CardContainer>
                  </Col>
                );
              })}
            </Row>
          )}
        </HeroWrapper>
      </Wrapper>
    );
  }
}

const colStyle = {
  marginTop: "40px",
};

const Wrapper = styled.div`
  margin-bottom: 65px;
  background-color: ${(props) =>
    props.bgcolor === "white" ? "white" : theme.colors.tones.lightest};
  padding: 30px 0;
`;

const HeroWrapper = styled(Container)`
  padding: 0 20px;
  ${media.lg`
                    padding: 0 20%;
                    `}
`;
const Heading = styled.h3`
  text-align: center;
  margin-bottom: 40px;
  font-size: 1.414em !important;
  font-weight: 350 !important;
`;

const CardContainer = styled(Link)`
  :hover .image {
    transform: scale(1.1);
    filter: blur(2px);
  }

  :hover .image::after {
    opacity: 0.2;
  }

  :hover .text {
    opacity: 1;
    top: 50%;
  }
`;
const ImgContainer = styled.div`
  overflow: hidden;
  position: relative;
`;
const InText = styled.p`
  position: absolute;
  z-index: 100;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  opacity: 0;
  transition: all 0.25s ease;
  font-family: "Work Sans";
  text-transform: uppercase;
  font-size: ${(props) => (props.textSize === 4 ? "0.8rem" : "1rem")};
`;

const Img = styled.div`
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  padding-top: 56%;
  background-color: white;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("${(props) => props.img}");
  margin: auto;

  &&::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #004077;
    opacity: 0;
    transition: 0.5s ease all;
  }

  transition: all 0.25s;
`;
const UnderText = styled.div`
  text-align: center;
  background-color: #004077;
  padding: 20px;
  color: white;
  text-transform: uppercase;
  font-size: 3vw;
  ${media.md`
font-size: 1.5vw;
`}

  ${media.lg`
font-size: 0.8vw;
`}
`;



// WEBPACK FOOTER //
// ./src/ui/components/modules/CategoriesButton/index.js